import React, { createContext, useContext, useState ,useEffect } from 'react'
import axios from "axios";

/**
 const AuthContext = createContext();
 export const useAuth = () => useContext(AuthContext)

 export const AuthProvider = ({children}) => {
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAuthenticated') === 'true'
    })
    const login = () => {
        setIsAuthenticated(true)
        localStorage.setItem('isAuthenticated', true)
    }

    const logout = () => {
        axios.post(`${serviceAPI}/auth/logout`, {}, { withCredentials: true });
        setIsAuthenticated(false)
        localStorage.removeItem('isAuthenticated')
    }

    return (
        <AuthContext.Provider value={{isAuthenticated, login, logout}}>
            {children}
        </AuthContext.Provider>
    )
}

 **/

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const serviceAPI = process.env.REACT_APP_API_SERVICE;

    // Check if session exists on page load
    useEffect(() => {
        const checkSession = async () => {
            try {
                const token = localStorage.getItem('jwt_token');
                const response = await axios.get(`${serviceAPI}/auth/session`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                console.log(response);
                if (response.status === 200) {
                    setIsAuthenticated(true);
                    //localStorage.setItem('isAuthenticated', 'true');
                }
            } catch (error) {
                setIsAuthenticated(false);
                localStorage.removeItem('jwt_token');
            }
        };
        checkSession();
    }, []);

    const login = (token) => {
        localStorage.setItem('jwt_token', token);  // Store JWT token in localStorage
        setIsAuthenticated(true);
    };

    const logout = () => {
        //axios.post(`${serviceAPI}/auth/logout`, {}, { withCredentials: true });
        //setIsAuthenticated(false);
        localStorage.removeItem('jwt_token');
        setIsAuthenticated(false);
    };

    return <AuthContext.Provider value={{ isAuthenticated, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);